/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReferralType = {
    HomeHealth: 'home_health',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Dialysis: 'dialysis',
    Other: 'other'
} as const;
export type ReferralType = typeof ReferralType[keyof typeof ReferralType];


export function instanceOfReferralType(value: any): boolean {
    for (const key in ReferralType) {
        if (Object.prototype.hasOwnProperty.call(ReferralType, key)) {
            if (ReferralType[key as keyof typeof ReferralType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferralTypeFromJSON(json: any): ReferralType {
    return ReferralTypeFromJSONTyped(json, false);
}

export function ReferralTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralType {
    return json as ReferralType;
}

export function ReferralTypeToJSON(value?: ReferralType | null): any {
    return value as any;
}

export function ReferralTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ReferralType {
    return value as ReferralType;
}

